module.exports = __webpack_public_path__ + "img/bh_16.d682e619.jpg";